import { htmlToDOM, type DOMNode } from 'html-react-parser'
import shopInfos from 'template/infos'

// Use the existing HTML parser so entities and markup have the same meaning in
// server HTML and after hydration. Never turn scripts/styles into snippet text.
export const seoText = (value?: string): string => {
  if (!value) return ''
  const text = (node: DOMNode): string => {
    if (node.type === 'text' && 'data' in node) return node.data
    if ('name' in node && /^(script|style|noscript)$/i.test(node.name)) return ''
    if ('children' in node) {
      const content = node.children.map(child => text(child as DOMNode)).join('')
      return 'name' in node && /^(p|div|li|ul|ol|h[1-6]|br|hr|section|table|tr)$/i.test(node.name)
        ? ` ${content} ` : content
    }
    return ''
  }
  return htmlToDOM(value).map(text).join('').replace(/\s+/g, ' ').trim()
}

export const seoDescription = (value?: string, fallback?: string): string => {
  const text = seoText(value) || seoText(fallback) || seoText(shopInfos.description)
  if (text.length <= 170) return text
  const short = text.slice(0, 167)
  const boundary = short.lastIndexOf(' ')
  return `${short.slice(0, boundary > 120 ? boundary : short.length).trimEnd()}…`
}

export const seoTitle = (title?: string, siteName = shopInfos.name): string => {
  const text = seoText(title) || seoText(shopInfos.title) || siteName
  if (!siteName || text.toLocaleLowerCase().includes(siteName.toLocaleLowerCase())) return text
  return `${text} | ${siteName}`
}

export const absoluteSeoUrl = (path = ''): string => {
  const base = `${shopInfos.url.replace(/\/+$/, '')}/`
  try {
    const url = new URL(path, base)
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return base
    url.hash = ''
    return url.href
  } catch {
    return base
  }
}

export const isPrivateSeoPath = (path = ''): boolean =>
  /^\/(?:warenkorb|wunschliste|kundenkonto|newsletter|kasse|bestellung|meta-checkout|paypal-advanced-test|paypal-wallet-test)(?:\/|$)/.test(path.split(/[?#]/)[0])
